import { Component, OnInit, ViewChild } from '@angular/core';
import { DepositCrypto } from 'src/app/shared/models/deposit-crypto.model';
import { Pagination } from 'src/app/shared/models/pagination.model';
import { ReportService } from 'src/app/shared/service/report.service';
import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import { CryptDepositHistoryComponent } from '../../../../../shared/components/crypt-deposit-history/crypt-deposit-history.component';

@Component({
  selector: 'app-deposit-crypto',
  templateUrl: './deposit-crypto.component.html',
  styleUrls: ['./deposit-crypto.component.scss']
})
export class DepositCryptoComponent implements OnInit {

  @ViewChild('CryptoDepositHistory') cryptoDepositHistory!: CryptDepositHistoryComponent;
  error: any = {};
  pagination: Pagination<DepositCrypto> = new Pagination<DepositCrypto>();
  includedUsers: User[] = [];
  redeemedGiftCardUserIds: User[] = [];
  selectedCurrency: Currency[] = [];

  constructor(private reportService: ReportService) {
  }

  getGiftCardList() {
    this.redeemedGiftCardUserIds = [...this.includedUsers];
  }

  report() {
    this.cryptoDepositHistory.getDepositList();
    this.getGiftCardList();
  }

  ngOnInit(): void {
  }
}
